import React from "react";
import PropTypes from "prop-types";
import ConnectedSubmit from "../../Pages/RegistrationPage/ConnectedSubmit";

const RegistrationPageSubmit = ({ showRemainingForm = true, controlId }) =>
    showRemainingForm && <ConnectedSubmit controlId={controlId} />;

RegistrationPageSubmit.propTypes = {
    showRemainingForm: PropTypes.bool,
    controlId: PropTypes.number.isRequired,
};

export default RegistrationPageSubmit;
